import { useQuery } from "@tanstack/react-query";
import { HardwareSupportFaqService } from "@/services/hardware-support-faq/hardware-support-faq-service";

export interface Faq {
  id: string;
  question: string;
  answer: string | null;
}

const faqService = new HardwareSupportFaqService();

export const useHardwareSupportFaq = () => {
  return useQuery<Faq[], Error>({
    queryKey: ["hardware-support-faq"],
    queryFn: () => faqService.getFaq(),
  });
};
